"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 *
 */
var Visitor = function () {
  function Visitor() {
    _classCallCheck(this, Visitor);
  }

  _createClass(Visitor, [{
    key: "onSurfaceMount",

    /**
     *
     */
    value: function onSurfaceMount(surface) {} // eslint-disable-line no-unused-vars
    /**
     *
     */

  }, {
    key: "onSurfaceUnmount",
    value: function onSurfaceUnmount(surface) {} // eslint-disable-line no-unused-vars
    /**
     *
     */

  }, {
    key: "onSurfaceGLContextChange",
    value: function onSurfaceGLContextChange(surface, gl) {} // eslint-disable-line no-unused-vars
    /**
     */

  }, {
    key: "onSurfaceDrawSkipped",
    value: function onSurfaceDrawSkipped(surface) {} // eslint-disable-line no-unused-vars
    /**
     */

  }, {
    key: "onSurfaceDrawStart",
    value: function onSurfaceDrawStart(surface) {} // eslint-disable-line no-unused-vars
    /**
     */

  }, {
    key: "onSurfaceDrawError",
    value: function onSurfaceDrawError(e) {} // eslint-disable-line no-unused-vars
    /**
     */

  }, {
    key: "onSurfaceDrawEnd",
    value: function onSurfaceDrawEnd(surface) {} // eslint-disable-line no-unused-vars
    /**
     */

  }, {
    key: "onNodeDrawSkipped",
    value: function onNodeDrawSkipped(node) {} // eslint-disable-line no-unused-vars
    /**
     */

  }, {
    key: "onNodeDrawStart",
    value: function onNodeDrawStart(node) {} // eslint-disable-line no-unused-vars
    /**
     */

  }, {
    key: "onNodeSyncDeps",
    value: function onNodeSyncDeps(node, additions, deletions) {} // eslint-disable-line no-unused-vars
    /**
     */

  }, {
    key: "onNodeDraw",
    value: function onNodeDraw(node, preparedUniforms) {} // eslint-disable-line no-unused-vars
    /**
     */

  }, {
    key: "onNodeDrawEnd",
    value: function onNodeDrawEnd(node) {} // eslint-disable-line no-unused-vars

  }]);

  return Visitor;
}();

exports.default = Visitor;
//# sourceMappingURL=Visitor.js.map


//////////////////
// WEBPACK FOOTER
// ./~/gl-react/lib/Visitor.js
// module id = 83
// module chunks = 0